import React, { useEffect, useRef, useState, useMemo } from 'react';
import { get, post, put, patch, destroy } from '../../../services/apiController';
import { TABLE_DEFAULT_LIMIT, units } from '../../../util/constant';
import { Button, Col, FloatingLabel, Form, Modal, Row, Table, Spinner } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';
import { ViewIcon, DownloadIcon, UploadIcon, EditIcon } from '../../icons';
import 'react-toastify/dist/ReactToastify.css';
import PaginationInPage from '../../Pagination';
import { MdDelete } from 'react-icons/md';
import { get_auth_key, getStoredData } from '../../../util';
import { GrDocumentPdf, GrDocumentExcel } from 'react-icons/gr';
import { FaQrcode } from 'react-icons/fa';
import Input from '../../../components/atoms/Input';
import Company from '../../../components/company';
import Factory from '../../../components/factory';
import GrnDetail from './grnDetail';
import Vendor from '../../../components/vendor';
import Item from '../../../components/item';
import { GetSingleVendor } from '../../../components/vendor/singleVendor';
import moment from 'moment';
import GrnPreview from './grnPreview';
import Kitchen from '../../../components/Kitchen';
import { GetJWVendorDetails } from '../jw-grn/helper';
import { formatDate, QrCodeDownload } from '../../../util/helper';
import QRCode from 'react-qr-code';
import AddInvDebitNoteModal from '../debit-note/components/add';
import { getLocationsForUser } from '../../../helpers/location.helper';
import { isAdmin } from '../../../helpers/role.helper';
import DatePickerComponent from '../../../components/common/date-picker';
import { useForm } from 'react-hook-form';
import { getQueryParams } from '../../../helpers/inv-grn';
import { AiOutlineFileAdd } from 'react-icons/ai';
import SearchVendor from '../../../components/common/vendor';
import { TbShoppingCartMinus } from 'react-icons/tb';
import { MdOutlineAddTask } from 'react-icons/md';
import Branch from '../../../components/common/branch';

const GRN = ({ grnType }) => {
  const baseURL = grnType === 'JW' ? '/inv/jw' : '/inv/grns';
  const storedData = JSON.parse(getStoredData(get_auth_key()));
  const admins = ['admin', 'super-admin', 'inventory-admin'].includes(storedData.role);
  const [debitNoteData, setDebitNoteData] = useState({
    open: false,
    grnId: '',
  });

  const minDate = moment().subtract(1, 'week').format('YYYY-MM-DD');
  const maxDate = moment().format('YYYY-MM-DD');

  const formFields = {
    companyId: 1,
    chargeType: '',
    chargeAmount: '',
    grnNumber: '',
    grnDate: moment().format('YYYY-MM-DD'),
    total: '',
    assetsInfo: [],
    factoryId: !admins ? storedData?.locationId[0] || '' : '',
    locationId: !admins ? storedData?.locationId[0] || '' : '',
    kitchenId: '',
  };

  const [totalRecords, setTotalRecords] = useState(0);
  const [grnForm, setGrnForm] = useState(formFields);
  const [showConfirmModel, setShowConfirmModel] = useState(false);
  const [grnList, setGrnList] = useState([]);
  const [itemList, setItemList] = useState([]);
  const [locationList, setLocationList] = useState([]);
  const [inputFields, setInputFields] = useState([]);
  const [view, setView] = useState(false);
  const intialTotals = { _totalCGST: 0, _totalIGST: 0, _totalSGST: 0, _totalWithoutGST: 0 };
  const [totals, setTotals] = useState(intialTotals);
  const [subTotal, setSubTotal] = useState(0);

  const clickAssetBtn = useRef(null);
  const clickSubmitBtn = useRef(null);
  const clickToDownload = useRef(null);
  const [uploadModel, setUploadModel] = useState(false);
  const [idToUpdated, setIdToUpdated] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [locationType, setLocationType] = useState('');
  const [viewDetail, setViewDetail] = useState(false);
  const [grnPreview, setGrnPreview] = useState(false);

  const [state, setState] = useState({
    locationId: !admins ? storedData?.locationId[0] || '' : '',
    dateFrom: moment().format('YYYY-MM-DD'),
    dateTo: moment().format('YYYY-MM-DD'),
    invoiceStartDate: '',
    invoiceEndDate: '',
    companyId: 1,
    kitchenId: '',
    vendorId: '',
  });

  const form = useForm({
    defaultValues: {
      page: 1,
      locationId: !admins ? storedData?.locationId[0] || '' : '',
      dateFrom: moment().format('YYYY-MM-DD'),
      dateTo: moment().format('YYYY-MM-DD'),
      invoiceStartDate: '',
      invoiceEndDate: '',
      companyId: 1,
      kitchenId: '',
      vendorId: '',
      itemId: '',
    },
  });

  const [duplicateCheckTimer, setDuplicateCheckTimer] = useState(null);
  const [isCheckingDuplicate, setIsCheckingDuplicate] = useState(false);
  const [isDuplicateInvoice, setIsDuplicateInvoice] = useState(false);
  const [showDraftsModal, setShowDraftsModal] = useState(false);
  const [showDraftNameModal, setShowDraftNameModal] = useState(false);
  const [drafts, setDrafts] = useState([]);
  const [currentDraft, setCurrentDraft] = useState(null);
  const [draftName, setDraftName] = useState('');
  const [isSavingDraft, setIsSavingDraft] = useState(false);
  const [isLoadingDrafts, setIsLoadingDrafts] = useState(false);

  function calculateGRNNumber() {
    get(`${baseURL}/number?grnDate=${grnForm.grnDate}&factoryId=${grnType === 'JW' ? grnForm.locationId : grnForm.factoryId}`).then(
      (response) => {
        setGrnForm({ ...grnForm, grnNumber: response.data });
      }
    );
  }

  function getLocations() {
    try {
      get(`/branches`).then((response) => {
        setLocationList(response.data.rows);
        if (!admins) {
          const data = response?.data?.rows?.find((item) => {
            return item.id === storedData?.locationId[0];
          });
          setLocationType(data?.type);
        }
      });
    } catch (err) {
      toast.error(err.response.data.data.message);
    }
  }

  const handleShow = async () => {
    setShowConfirmModel(true);
    setView(false);
    setGrnForm(formFields);
    setInputFields([]);
    setTotals(intialTotals);
    setSubTotal(0);
    setCurrentDraft(null);
    calculateGRNNumber();

    setTimeout(() => {
      clickAssetBtn.current?.click();
    }, 100);
  };

  const handleClose = async () => {
    setShowConfirmModel(false);
    setInputFields([]);
    setGrnForm(formFields);
    setView(false);
    setIsLoading(false);
    setTotals(intialTotals);
    setSubTotal(0);
    setViewDetail(false);
  };

  const handleViewAndEdit = (e, id, view, conditionType) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      if (conditionType === 'edit') setShowConfirmModel(true);
      else if (conditionType === 'view') setViewDetail(true);
      get(`${baseURL}/${id}/?conditionType=${conditionType}`).then(async (res) => {
        const Data = res.data;
        const locationData = loadLocationData(Data.factoryId);
        Data.companyId = locationData?.companyId ?? 1;

        if (conditionType !== 'download') {
          const vendorData = grnType === 'JW' ? await GetJWVendorDetails(Data.kitchenId) : await GetSingleVendor(Data.vendorId);
          setGrnForm({
            ...Data,
            supplierGstin: vendorData?.gst_num || '',
            supplierAddress: vendorData?.address || '',
            supplierContactNumber: vendorData?.contact_num || '',
          });
          let _inputFields = Data.assetsInfo;
          let _totalWithoutGST = 0;
          let _totalCGST = 0;
          let _totalSGST = 0;
          let _totalIGST = 0;
          for (let x = 0; x < _inputFields.length; x++) {
            if (_inputFields[x].quantityReceived !== -1) {
              let totalWithoutGST = _inputFields[x].quantityReceived * _inputFields[x].rate;
              let totalSGST = (totalWithoutGST * _inputFields[x].sgst) / 100;
              let totalCGST = (totalWithoutGST * _inputFields[x].cgst) / 100;
              let totalIGST = (totalWithoutGST * _inputFields[x].igst) / 100;

              _inputFields[x]['totalWithoutGST'] = totalWithoutGST;
              _inputFields[x]['totalCGST'] = totalCGST;
              _inputFields[x]['totalSGST'] = totalSGST;
              _inputFields[x]['totalIGST'] = totalIGST;

              _totalWithoutGST += parseFloat(totalWithoutGST || 0);
              _totalCGST += parseFloat(totalCGST || 0);
              _totalSGST += parseFloat(totalSGST || 0);
              _totalIGST += parseFloat(totalIGST || 0);
            }
          }
          setInputFields(_inputFields);
          setView(view);
          setTotals({ ...totals, _totalWithoutGST, _totalCGST, _totalIGST, _totalSGST });
          setSubTotal(Data.totalAmount);
          setCurrentDraft(null);
          setIsLoading(false);
        } else {
          clickToDownload.current.href = `${process.env.REACT_APP_BASE_URL}/file/download?filePath=${res.data}`;
          setTimeout(() => {
            clickToDownload.current.click();
          }, 500);
          setIsLoading(false);
        }
      });
    } catch (error) {
      setIsLoading(false);
      toast.error(error?.response?.data?.data?.rows?.message || 'Something went wrong');
    }
  };

  const downloadQrCode = (e, item) => {
    e.preventDefault();
    QrCodeDownload(
      `temp-qr-${item.id}`,
      item.grnNumber,
      grnType === 'JW' ? item?.Kitchen?.name : item?.VendorMaster?.name || item?.supplierName
    );
  };

  const getGrnUrl = (itemId) => {
    return window.location.origin + (grnType === 'JW' ? `/#/inv/jw-grn/print/${itemId}` : `/#/inv/grn/print/${itemId}`);
  };

  const uploadInvoice = (e, id) => {
    e.preventDefault();
    setIdToUpdated(id);
    setUploadModel(true);
  };

  let formData = new FormData();
  const handleFileChange = (e) => {
    e.preventDefault();
    formData.append('invoice', e.target.files[0]);
  };

  const handleUpload = async (e, id) => {
    e.preventDefault();
    try {
      patch(formData, `${baseURL}/${id}`, false)
        .then((res) => {
          toast.success(res?.data?.message);
          setUploadModel(false);
          setIdToUpdated('');
          getGRNs();
        })
        .catch((err) => {
          toast.error(err?.response?.data?.data?.message);
        });
    } catch (err) {
      toast.error(err?.message || 'Something Went Wrong');
    }
  };

  const handleChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    let _grnForm = { ...grnForm, [name]: value };

    if (name === 'chargeAmount') {
      let totalChargeAmount = _grnForm.assetsInfo.reduce(
        (acc, asset) => {
          return acc + parseFloat(asset.invoiceAmount || 0);
        },
        parseFloat(value) || 0
      );
      setSubTotal(totalChargeAmount);
    }

    if (name === 'invoiceDate') {
      _grnForm = { ..._grnForm, poDate: moment(value, 'YYYY-MM-DD').subtract(1, 'days').format('YYYY-MM-DD') };
    }

    if (name === 'supplierInvoiceNumber') {
      debouncedCheckDuplicate(value, _grnForm.vendorId);
    }

    setGrnForm(_grnForm);
  };

  const handleVendorChange = async (vendorId) => {
    try {
      const vendorData = await GetSingleVendor(vendorId);
      const updatedGrnForm = {
        ...grnForm,
        vendorId,
        supplierName: vendorData?.name || '',
        supplierGstin: vendorData?.gst_num || '',
        supplierAddress: vendorData?.address || '',
        supplierContactNumber: vendorData?.contact_num || '',
      };

      setGrnForm(updatedGrnForm);

      if (updatedGrnForm.supplierInvoiceNumber) {
        debouncedCheckDuplicate(updatedGrnForm.supplierInvoiceNumber, vendorId);
      }
    } catch (error) {
      console.error('Error handling vendor change:', error);
    }
  };

  const handleKitchenChange = async (kitchenId) => {
    try {
      const vendorData = await GetJWVendorDetails(kitchenId);
      setGrnForm({
        ...grnForm,
        kitchenId,
        supplierName: vendorData?.name || '',
        supplierGstin: vendorData?.gst_num || '',
        supplierAddress: vendorData?.address || '',
        supplierContactNumber: vendorData?.contact_num || '',
      });
    } catch (error) {
      console.error('Error handling vendor change:', error);
    }
  };

  useEffect(() => {
    if (grnForm.grnDate && grnForm.companyId && (grnForm.factoryId || grnForm.locationId) && view === false && showConfirmModel) {
      calculateGRNNumber();
    }
  }, [grnForm.grnDate, grnForm.companyId, grnForm.factoryId, grnForm.locationId, showConfirmModel]);

  useEffect(() => {
    return () => {
      if (duplicateCheckTimer) {
        clearTimeout(duplicateCheckTimer);
      }
    };
  }, [duplicateCheckTimer]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    const postData = { ...grnForm, subTotal: subTotal, grnType };
    // If invoice not uploaded in JW grn
    if (!postData.invoice && grnType === 'JW' && !postData.id) {
      toast.error('Please upload invoice');
      setLoading(false);
      return;
    }
    const formData = new FormData();
    for (const key in postData) {
      if (key === 'invoice' || key === 'assetsInfo') continue;
      formData.append(key, postData[key]);
    }
    if (postData.assetsInfo && Array.isArray(postData.assetsInfo) && postData?.assetsInfo.length > 0) {
      formData.append('assetsInfo', JSON.stringify(postData.assetsInfo));
    }
    if (postData.invoice) formData.append('invoice', postData['invoice']);
    if ('id' in grnForm) {
      try {
        await put(formData, `${baseURL}/${postData.id}`, false);
        setLoading(false);
        toast.success('GRN updated successfully');

        setShowConfirmModel(false);
        setInputFields([]);
        setGrnForm(formFields);
        setView(false);
        setTotals(intialTotals);
        setSubTotal(0);

        getGRNs();
      } catch (err) {
        setLoading(false);
        toast.error(err?.response?.data?.data?.message || err.message, {
          autoClose: 4000,
        });
      }
    } else {
      try {
        /** Invoice date validation for JW GRN */
        if (!admins && grnType === 'JW' && moment(grnForm.invoiceDate).isBefore(minDate)) {
          toast.error("Invoice date can't be older than one week.");
          setLoading(false);
          return;
        }
        await post(formData, baseURL, false);
        setLoading(false);
        toast.success('GRN created successfully');

        setShowConfirmModel(false);
        setInputFields([]);
        setGrnForm(formFields);
        setView(false);
        setTotals(intialTotals);
        setSubTotal(0);

        getGRNs();
      } catch (err) {
        setLoading(false);
        toast.error(err?.response?.data?.data?.message || err.message, {
          autoClose: 4000,
        });
        if (err?.response?.data?.data?.message.startsWith('We already') === true) {
          calculateGRNNumber();
          clickSubmitBtn.current.click();
        }
      }
    }
  };

  function getGRNs(conditionType) {
    try {
      const currentPage = form.getValues('page');
      const filters = new URLSearchParams(getQueryParams(form, currentPage, conditionType));
      const filtersString = filters.size > 0 ? `?${filters}` : '';
      let url = `${baseURL}${filtersString}`;

      get(url).then((response) => {
        if (conditionType === 'download') {
          clickToDownload.current.href = `${process.env.REACT_APP_BASE_URL}/file/download?filePath=${response.data.filePath}`;
          setTimeout(() => {
            clickToDownload.current.click();
          }, 500);
        } else {
          setGrnList(response.data.rows);
          setTotalRecords(response.data.count);
        }
      });
    } catch (err) {
      toast.error(err.response.data.data.message);
    }
  }

  const getItems = useMemo(() => {
    return () => {
      try {
        get(`/inv/items`).then((response) => {
          setItemList(response.data.rows);
        });
      } catch (err) {
        toast.error(err?.response?.data?.data?.message || err?.message);
      }
    };
  }, []);

  useEffect(() => {
    getItems();
    getLocations();
  }, []);

  const handleAddInput = async () => {
    const newAssetInfo = [...inputFields];
    newAssetInfo.push({
      itemId: '',
      description: '',
      unit: '',
      quantityAsPerInvoice: '',
      quantityReceived: '',
      rate: '',
      totalgst: '',
      gstType: '',
      cgst: 0,
      sgst: 0,
      igst: 0,
      invoiceAmount: '',
      quantityRejected: '',
      remarksForRejection: '',
    });
    setInputFields(newAssetInfo);
    setGrnForm({ ...grnForm, assetsInfo: newAssetInfo });
  };

  const handleRemoveInput = (index) => {
    const newAssetInfo = [...inputFields];
    setTotals({
      _totalWithoutGST: parseInt(totals._totalWithoutGST) - parseInt(newAssetInfo[index]['totalWithoutGST'] || 0),
      _totalCGST: parseInt(totals._totalCGST) - parseInt(newAssetInfo[index]['totalCGST'] || 0),
      _totalIGST: parseInt(totals._totalIGST) - parseInt(newAssetInfo[index]['totalIGST'] || 0),
      _totalSGST: parseInt(totals._totalSGST) - parseInt(newAssetInfo[index]['totalSGST'] || 0),
    });
    setSubTotal(parseInt(subTotal) - parseInt(newAssetInfo[index]['invoiceAmount'] || 0));
    newAssetInfo.splice(index, 1);
    setInputFields(newAssetInfo);
    setGrnForm({ ...grnForm, assetsInfo: newAssetInfo });
  };

  const calculateTotal = (Qty, cost_per_unit, totalgst) => {
    const total = (Qty || 0) * (cost_per_unit || 0) + ((Qty || 0) * (cost_per_unit || 0) * totalgst) / 100;
    return total.toFixed(2);
  };

  const loadLocationData = (locationId) => {
    return locationList.find((item) => {
      return item?.id === parseInt(locationId);
    });
  };

  const handleItemChange = (index, itemId) => {
    let newAssetInfo = [...inputFields];
    newAssetInfo[index].itemId = itemId;
    const foundItem = itemList.find((item) => item.id === +itemId);
    if (foundItem) {
      newAssetInfo[index].unit = foundItem.unit;
      newAssetInfo[index].itemName = foundItem?.name;
      newAssetInfo[index].hsnCode = foundItem?.hsnCode ?? '';
    } else {
      newAssetInfo[index].unit = '';
      newAssetInfo[index].hsnCode = '';
    }
    setInputFields(newAssetInfo);
    setGrnForm({ ...grnForm, assetsInfo: newAssetInfo });
  };

  const handleInputChange = (index, event, fieldName) => {
    let newAssetInfo = [...inputFields];
    newAssetInfo[index][fieldName] = event.target.value;
    if (fieldName === 'unit') {
      if (event.target.value !== '') newAssetInfo[index].unit = event.target.value;
    }

    if (fieldName === 'gstType') {
      newAssetInfo[index]['sgst'] = 0;
      newAssetInfo[index]['cgst'] = 0;
      newAssetInfo[index]['igst'] = 0;
      newAssetInfo[index]['totalgst'] = 0;
    }

    if (
      fieldName === 'rate' ||
      fieldName === 'quantityAsPerInvoice' ||
      fieldName === 'quantityReceived' ||
      fieldName === 'cgst' ||
      fieldName === 'igst' ||
      fieldName === 'gstType'
    ) {
      let quantity =
        fieldName === 'quantityAsPerInvoice' ? newAssetInfo[index]['quantityAsPerInvoice'] : newAssetInfo[index]['quantityReceived'];
      let rate = newAssetInfo[index]['rate'];
      let totalgst = newAssetInfo[index]['totalgst'];
      if (fieldName === 'quantityReceived') {
        quantity = event.target.value;
      }
      if (fieldName === 'rate') {
        rate = event.target.value;
      }
      if (fieldName === 'cgst' || fieldName === 'igst') {
        newAssetInfo[index][fieldName] = event.target.value;
        const cgst = parseFloat(newAssetInfo[index]['cgst'] || 0);
        newAssetInfo[index]['sgst'] = cgst;
        const sgst = parseFloat(newAssetInfo[index]['sgst'] || 0);
        const igst = parseFloat(newAssetInfo[index]['igst'] || 0);
        totalgst = cgst + sgst + igst;
        newAssetInfo[index]['totalgst'] = totalgst;
      }
      newAssetInfo[index]['totalCGST'] = (quantity * rate * newAssetInfo[index]['cgst']) / 100;
      newAssetInfo[index]['totalSGST'] = (quantity * rate * newAssetInfo[index]['sgst']) / 100;
      newAssetInfo[index]['totalIGST'] = (quantity * rate * newAssetInfo[index]['igst']) / 100;
      newAssetInfo[index]['totalWithoutGST'] = quantity * rate;
      newAssetInfo[index]['invoiceAmount'] = calculateTotal(quantity, rate, newAssetInfo[index]['totalgst'] || 0);
    }

    if (fieldName === 'quantityAsPerInvoice') {
      newAssetInfo[index]['quantityReceived'] = newAssetInfo[index]['quantityAsPerInvoice'];
      newAssetInfo[index]['quantityRejected'] = 0;
    }
    if (fieldName === 'quantityReceived') {
      newAssetInfo[index]['quantityRejected'] =
        newAssetInfo[index]['quantityAsPerInvoice'] -
        (newAssetInfo[index]['quantityReceived'] || newAssetInfo[index]['quantityAsPerInvoice']);
    }

    let amount = 0;
    let _totalWithoutGST = 0;
    let _totalCGST = 0;
    let _totalSGST = 0;
    let _totalIGST = 0;
    for (let i = 0; i < newAssetInfo.length; i++) {
      _totalWithoutGST += parseFloat(newAssetInfo[i]?.totalWithoutGST || 0);
      _totalCGST += parseFloat(newAssetInfo[i]?.totalCGST || 0);
      _totalSGST += parseFloat(newAssetInfo[i]?.totalSGST || 0);
      _totalIGST += parseFloat(newAssetInfo[i]?.totalIGST || 0);
      amount += parseFloat(newAssetInfo[i]?.invoiceAmount || 0);
    }
    setTotals({ ...totals, _totalWithoutGST, _totalSGST, _totalCGST, _totalIGST });
    setSubTotal(amount + parseInt(grnForm?.chargeAmount || 0));
    setInputFields(newAssetInfo);
    setGrnForm({ ...grnForm, assetsInfo: newAssetInfo });
  };

  const handleCheckDuplicateInvoiceNumber = async (invoiceNumber, vendorId) => {
    const currentInvoiceNumber = invoiceNumber || grnForm.supplierInvoiceNumber;
    const currentVendorId = vendorId || grnForm.vendorId;

    if (!currentInvoiceNumber || !currentVendorId) {
      setIsDuplicateInvoice(false);
      return;
    }

    setIsCheckingDuplicate(true);

    try {
      await post(
        {
          supplierInvoiceNumber: currentInvoiceNumber,
          vendorId: currentVendorId,
          grnDate: grnForm.grnDate,
        },
        `${baseURL}/check-duplicate-invoice-number`
      );
      setIsDuplicateInvoice(false);
    } catch (err) {
      setIsDuplicateInvoice(true);
    } finally {
      setIsCheckingDuplicate(false);
    }
  };

  const debouncedCheckDuplicate = (invoiceNumber, vendorId) => {
    if (duplicateCheckTimer) {
      clearTimeout(duplicateCheckTimer);
    }

    const timer = setTimeout(() => {
      if (invoiceNumber && vendorId) {
        handleCheckDuplicateInvoiceNumber(invoiceNumber, vendorId);
      }
    }, 500);

    setDuplicateCheckTimer(timer);
  };

  // Load all drafts
  const loadDrafts = async () => {
    setIsLoadingDrafts(true);
    try {
      const response = await get(`/user-draft/grn_${grnType === 'JW' ? 'jw_grn' : 'grn'}/drafts`);
      if (response.data && response?.data?.data) {
        setDrafts(response.data.data);
      }
    } catch (error) {
      console.error('Error loading drafts:', error);
      toast.error('Failed to load drafts');
    } finally {
      setIsLoadingDrafts(false);
    }
  };

  // Load specific draft
  const loadDraft = async (draftId) => {
    try {
      const response = await get(`/user-draft/draft/${draftId}`);
      if (response.data && response?.data?.data) {
        const savedData = response.data.data.saveData;
        const fieldsData = savedData.inputFields || savedData.grnForm?.assetsInfo || [];
        setGrnForm({
          ...savedData.grnForm,
          assetsInfo: fieldsData,
        });
        setInputFields(fieldsData);
        setTotals(savedData.totals);
        setSubTotal(savedData.subTotal);
        setCurrentDraft(response.data.data);
        setShowDraftsModal(false);
        setShowConfirmModel(true);
        toast.success('Draft loaded successfully');
      }
    } catch (error) {
      console.error('Error loading draft:', error);
      toast.error('Failed to load draft');
    }
  };

  // Delete draft
  const deleteDraft = async (draftId) => {
    try {
      await destroy(`/user-draft/draft/${draftId}`);
      toast.success('Draft deleted successfully');
      loadDrafts();
    } catch (error) {
      console.error('Error deleting draft:', error);
      toast.error('Failed to delete draft');
    }
  };

  // Save draft
  const saveDraft = async () => {
    if (view || grnForm.id) return;

    const saveData = {
      grnForm: {
        ...grnForm,
        assetsInfo: inputFields,
      },
      inputFields,
      totals,
      subTotal,
    };

    if (currentDraft) {
      setIsSavingDraft(true);
      try {
        await put(
          {
            saveData,
          },
          `/user-draft/draft/${currentDraft.id}`
        );
        toast.success('Draft updated successfully');
      } catch (error) {
        console.error('Error saving draft:', error);
        toast.error('Failed to save draft');
      } finally {
        setIsSavingDraft(false);
      }
    } else {
      setShowDraftNameModal(true);
    }
  };

  // Create new draft with name
  const createDraft = async () => {
    if (!draftName.trim()) {
      toast.error('Please enter a draft name');
      return;
    }

    setIsSavingDraft(true);
    try {
      const saveData = {
        grnForm: {
          ...grnForm,
          assetsInfo: inputFields,
        },
        inputFields,
        totals,
        subTotal,
      };

      const response = await post(
        {
          saveType: `grn_${grnType === 'JW' ? 'jw_grn' : 'grn'}`,
          name: draftName,
          saveData,
        },
        '/user-draft/save'
      );

      if (response.data && response?.data?.data) {
        setCurrentDraft(response.data.data);
      }

      setShowDraftNameModal(false);
      setDraftName('');
      toast.success('Draft created successfully');
    } catch (error) {
      console.error('Error creating draft:', error);
      toast.error('Failed to create draft');
    } finally {
      setIsSavingDraft(false);
    }
  };

  const onDebitNoteCreate = (grnId) => {
    setDebitNoteData({
      open: true,
      grnId,
    });
  };

  const [vendorId, invoiceStartDate, invoiceEndDate, locationId, dateFrom, dateTo, kitchenId, itemId] = form.watch([
    'vendorId',
    'invoiceStartDate',
    'invoiceEndDate',
    'locationId',
    'dateFrom',
    'dateTo',
    'kitchenId',
    'itemId',
  ]);

  useEffect(() => {
    form.setValue('page', 1);
    getGRNs();
  }, [vendorId, invoiceStartDate, invoiceEndDate, locationId, dateFrom, dateTo, kitchenId, itemId]);

  return (
    <React.Fragment>
      <ToastContainer />
      <div className="row justify-content-between align-items-center mt-2">
        <div className="col-12 text-end mb-2"></div>
      </div>
      <div className="card">
        <div className="d-flex justify-content-between align-items-center w-100 card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          <div style={{ flex: 1 }}>
            <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
              {grnType === 'JW' ? 'JW GRN' : 'GRN'} | {totalRecords ?? 0}
            </h4>
          </div>
          <div style={{ flex: 4 }}>
            <div className="row w-100 align-items-center">
              <div className="col-lg-3">
                <Company
                  label="Company"
                  disabled
                  company={state.companyId}
                  value={state.companyId}
                  onChange={(e) => {
                    setState({
                      ...state,
                      companyId: e.target.value,
                      locationId: '',
                    });
                    setLocationType('');
                  }}
                />
                <Form.Select
                  disabled={!admins}
                  value={locationType}
                  onChange={(e) => {
                    setLocationType(e.target.value);
                    form.setValue('locationId', '');
                  }}
                  className="input mt-2"
                >
                  <option value="">Select Location Type</option>
                  <option value="office">Office</option>
                  <option value="factory">Factory</option>
                  <option value="outlet">Outlet</option>
                  <option value="staff-room">Staff Room</option>
                </Form.Select>
                <Factory
                  className="mt-2"
                  label="Location"
                  disabled={!admins && grnType !== 'JW'}
                  value={state.locationId}
                  factoryId={state.locationId}
                  onChange={(e) => {
                    form.setValue('locationId', e.target.value);
                  }}
                  factories={locationList.filter((item) => {
                    if (admins) {
                      return item?.type === locationType && item?.companyId === parseInt(state?.companyId);
                    } else {
                      return (
                        storedData?.locationId.includes(item?.id) &&
                        item?.type === locationType &&
                        item?.companyId === parseInt(state?.companyId)
                      );
                    }
                  })}
                />
              </div>
              <div className="col-lg-3">
                <DatePickerComponent
                  onDateChange={(date) => {
                    form.setValue('dateFrom', date);
                  }}
                  placeholderText="GRN Start Date"
                  selectedDate={form.getValues('dateFrom')}
                />
                <div className="mt-2"></div>
                <DatePickerComponent
                  onDateChange={(date) => {
                    form.setValue('dateTo', date);
                  }}
                  placeholderText="GRN End Date"
                  selectedDate={form.getValues('dateTo')}
                />
              </div>
              <div className="col-lg-3">
                <DatePickerComponent
                  selectedDate={form.getValues('invoiceStartDate')}
                  onDateChange={(date) => {
                    form.setValue('invoiceStartDate', date);
                  }}
                  placeholderText="Invoice Start Date"
                />
                <div className="mt-2"></div>
                <DatePickerComponent
                  onDateChange={(date) => {
                    form.setValue('invoiceEndDate', date);
                  }}
                  placeholderText="Invoice End Date"
                  selectedDate={form.getValues('invoiceEndDate')}
                />
              </div>
              <div className="col-lg-3">
                {grnType === 'JW' ? (
                  <>
                    <div className="form-floating text-start mb-2">
                      <Kitchen
                        query={`factoryId=116&type=JW`}
                        kitchenId={form.getValues('kitchenId')}
                        onChange={(kitchenId) => form.setValue('kitchenId', kitchenId)}
                        name={'kitchenId'}
                        label="Select Vendor"
                      />
                    </div>
                    <div className="form-floating text-start">
                      <Item
                        itemId={form.getValues('itemId')}
                        name="itemId"
                        onChange={(itemId) => {
                          form.setValue('itemId', itemId);
                        }}
                        query={grnType === 'JW' ? 'type=JW' : ''}
                      />
                    </div>
                  </>
                ) : (
                  <SearchVendor
                    onSelect={(vendor) => {
                      form.setValue('vendorId', vendor?.value || '');
                    }}
                  />
                )}
              </div>
            </div>
          </div>
          <div style={{ flex: 1 }}>
            <div className="row align-items-center">
              <div className="col-2">
                <GrDocumentExcel
                  title="Download Excel"
                  className="react-icons green"
                  style={{ width: '30px', height: '30px', cursor: 'pointer' }}
                  onClick={() => getGRNs('download')}
                />
              </div>
              <div className="col-10">
                <button
                  type="button"
                  className="btn app-btn-secondary btn-sm me-2"
                  onClick={() => {
                    loadDrafts();
                    setShowDraftsModal(true);
                  }}
                  style={{ minWidth: '80px' }}
                >
                  Load Drafts
                </button>
                <button type="button" className="btn app-btn-default dark-color btn-sm" onClick={handleShow} style={{ minWidth: '80px' }}>
                  {grnType === 'JW' ? 'Add JW GRN' : 'Add GRN'}
                </button>
                <a ref={clickToDownload} href="/" target="_blank" className="hiddenItem">
                  HiddenClick
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
          <div className="row">
            <div className="col">
              <Table responsive striped bordered>
                <thead>
                  <tr className="text-center">
                    <th rowSpan="2">#</th>
                    <th rowSpan="2">GRN No</th>
                    <th rowSpan="2">GRN Date</th>
                    <th rowSpan="2">Created Date</th>
                    <th rowSpan="2">Invoice Number</th>
                    <th rowSpan="2">Invoice Date</th>
                    <th rowSpan="2">Supplier Name</th>
                    <th rowSpan="2">{grnType === 'JW' ? 'Location Name' : 'Factory Name'}</th>
                    <th colSpan="3">GRN Details</th>
                    <th rowSpan="2">Raised By</th>
                    <th rowSpan="2">Actions</th>
                  </tr>
                  <tr className="text-center">
                    <th style={{ width: '150px', textAlign: 'center' }}>Item</th>
                    <th style={{ width: '150px', textAlign: 'center' }}>Quantity As Per Invoice</th>
                    <th style={{ width: '150px', textAlign: 'center' }}>Quantity Received</th>
                  </tr>
                </thead>
                <tbody>
                  {grnList?.map((item, index) => {
                    const rowSpan = item.items.length;
                    return (
                      <>
                        <tr role="row" key={item.grnNumber} className="text-center">
                          <td rowSpan={rowSpan}>{(form.getValues('page') - 1) * TABLE_DEFAULT_LIMIT + (index + 1)}</td>
                          <td rowSpan={rowSpan}>{item.grnNumber}</td>
                          <td rowSpan={rowSpan}>{formatDate(item.grnDate)}</td>
                          <td rowSpan={rowSpan}>{formatDate(item.createdAt, true)}</td>
                          <td rowSpan={rowSpan}>{item.supplierInvoiceNumber ?? '-'}</td>
                          <td rowSpan={rowSpan}>{formatDate(item.invoiceDate)}</td>
                          <td rowSpan={rowSpan}>{grnType === 'JW' ? item.kitchenName : item.vendorName}</td>
                          <td rowSpan={rowSpan}>{item.branchName}</td>
                          <td>{item.items[0].itemName}</td>
                          <td>{item.items[0].quantityAsPerInvoice}</td>
                          <td>{item.items[0].quantityReceived}</td>
                          <td rowSpan={rowSpan}>{item.userName}</td>
                          <td rowSpan={rowSpan} className="pe-2">
                            <div className="d-flex gap-2 justify-content-center flex-wrap">
                              <a href="/" onClick={(e) => uploadInvoice(e, item.id)}>
                                <UploadIcon style={{ color: 'green' }} />
                              </a>
                              {!item.DebitNote && (
                                <a href="/" onClick={(e) => handleViewAndEdit(e, item.id, true, 'edit')}>
                                  <EditIcon style={{ color: 'teal' }} />
                                </a>
                              )}
                              <a href="/" onClick={(e) => handleViewAndEdit(e, item.id, false, 'view')}>
                                <ViewIcon style={{ color: 'purple' }} />
                              </a>
                              <a
                                href={grnType === 'JW' ? `#/inv/jw-grn/print/${item.id}` : `#/inv/grn/print/${item.id}`}
                                target="_blank"
                                rel="noreferrer"
                              >
                                <GrDocumentPdf className="react-icons red" title="Print view" />
                              </a>
                              <a href="/" onClick={(e) => downloadQrCode(e, item)} title="Download QR Code">
                                <FaQrcode />
                              </a>
                              {/* Hidden QR Code for download */}
                              <div style={{ display: 'none' }}>
                                <QRCode
                                  id={`temp-qr-${item.id}`}
                                  value={getGrnUrl(item.id)}
                                  size={100}
                                  level="H"
                                  style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
                                />
                              </div>
                              {item.invoice && (
                                <a
                                  href={
                                    item.syncedOnBucket
                                      ? `${process.env.REACT_APP_DIGITAL_OCEAN_URL}/${item.invoice}`
                                      : `${process.env.REACT_APP_BASE_URL}/file/download?filePath=${item.invoice}`
                                  }
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  <DownloadIcon style={{ color: 'purple' }} />
                                </a>
                              )}
                              {!item.debitNoteId && grnType !== 'JW' && (
                                <MdOutlineAddTask
                                  color="#2196F3"
                                  title="Create Debit Note"
                                  className="cursor-pointer"
                                  onClick={() => onDebitNoteCreate(item.id)}
                                  size={20}
                                />
                              )}
                            </div>
                          </td>
                        </tr>
                        {item.items.slice(1).map((detail, _index) => {
                          return (
                            <tr key={`${item.grnNumber}-${_index}`} className="text-center">
                              <td>{detail.itemName}</td>
                              <td>{detail.quantityAsPerInvoice}</td>
                              <td>{detail.quantityReceived}</td>
                            </tr>
                          );
                        })}
                      </>
                    );
                  })}
                </tbody>
              </Table>
              <PaginationInPage
                currentPage={form.getValues('page')}
                setCurrentPage={(page) => {
                  form.setValue('page', page);
                  getGRNs();
                }}
                totalRecords={totalRecords}
                TABLE_DEFAULT_LIMIT={TABLE_DEFAULT_LIMIT}
              />
            </div>
          </div>
        </div>
      </div>
      {showConfirmModel && (
        <Modal size="lg" show={showConfirmModel} backdrop="static" keyboard={false} className="request-modal">
          <Modal.Header>
            <Modal.Title>
              {view === true && 'id' in grnForm ? 'GRN Details' : 'id' in grnForm ? 'Edit GRN' : isLoading ? 'Loading...' : 'Add GRN'}
            </Modal.Title>
            <button type="button" className="btn-close" aria-label="Close" onClick={handleClose}></button>
          </Modal.Header>
          <Modal.Body>
            {isLoading ? (
              <Spinner animation="border" variant="info" />
            ) : (
              <Form autoComplete="off" onSubmit={handleSubmit}>
                <h6>Basic Info</h6>
                <Row>
                  <Col xs={6}>
                    <FloatingLabel controlId="floatingInput" label="GRN Date" className="mb-3">
                      <Form.Control
                        disabled={view === true || !admins}
                        className="input"
                        value={grnForm.grnDate}
                        name="grnDate"
                        onChange={handleChange}
                        type="date"
                        placeholder="GRN Date"
                        required
                      />
                    </FloatingLabel>
                  </Col>

                  <Col xs={6}>
                    <FloatingLabel controlId="floatingInput" label="Company" className="mb-3">
                      <Company disabled company={grnForm.companyId} onChange={handleChange} label="Company" name="companyId" />
                    </FloatingLabel>
                  </Col>
                  <Col xs={6}>
                    <FloatingLabel controlId="floatingInput" label={grnType === 'JW' ? 'Location' : 'Factory'} className="mb-3">
                      {grnType === 'JW' ? (
                        <Factory
                          disabled={view === true}
                          factoryId={grnForm.locationId}
                          factories={
                            admins
                              ? locationList
                              : locationList.filter(
                                  (item) => storedData?.locationId.includes(item?.id) && item?.companyId === parseInt(grnForm?.companyId)
                                )
                          }
                          required
                          company={grnForm.companyId}
                          onChange={handleChange}
                          label="Location"
                          name="locationId"
                        />
                      ) : (
                        <Factory
                          disabled={view === true || !admins}
                          factoryId={grnForm.factoryId}
                          factories={locationList.filter((item) => {
                            if (admins) {
                              return item?.type === 'factory' && item?.companyId === parseInt(grnForm?.companyId);
                            } else {
                              return (
                                storedData?.locationId.includes(item?.id) &&
                                item?.type === 'factory' &&
                                item?.companyId === parseInt(grnForm?.companyId)
                              );
                            }
                          })}
                          required
                          company={grnForm.companyId}
                          onChange={handleChange}
                          label="Factory"
                          name="factoryId"
                        />
                      )}
                    </FloatingLabel>
                  </Col>
                  <Col xs={6}>
                    <FloatingLabel controlId="floatingInput" label="GRN No." className="mb-3">
                      <Form.Control
                        disabled
                        className="input"
                        name="grnNumber"
                        value={grnForm.grnNumber}
                        onChange={handleChange}
                        type="text"
                        placeholder="GRN No."
                        required
                      />
                    </FloatingLabel>
                  </Col>
                </Row>
                <Row>
                  <Col xs={6}>
                    {grnType === 'JW' ? (
                      <Kitchen
                        query={`factoryId=116&type=JW`}
                        kitchenId={grnForm.kitchenId}
                        onChange={(kitchenId) => handleKitchenChange(kitchenId)}
                        name={'kitchenId'}
                        label="Select Vendor"
                      />
                    ) : (
                      <Vendor
                        name="vendorId"
                        vendorId={grnForm?.vendorId}
                        handleVendorChange={(vendorId) => handleVendorChange(vendorId)}
                      />
                    )}
                  </Col>
                  <Col xs={6}>
                    <FloatingLabel controlId="floatingInput" label="Supplier Address" className="mb-3">
                      <Input
                        type="text"
                        name="supplierAddress"
                        value={grnForm.supplierAddress}
                        onChange={handleChange}
                        placeholder="Supplier Address"
                        disabled
                      />
                    </FloatingLabel>
                  </Col>
                  <Col xs={6}>
                    <FloatingLabel controlId="floatingInput" label="Supplier Contact number" className="mb-3">
                      <Input
                        type="text"
                        name="supplierContactNumber"
                        value={grnForm.supplierContactNumber}
                        onChange={handleChange}
                        placeholder="Supplier Contact number"
                        disabled
                      />
                    </FloatingLabel>
                  </Col>
                  <Col xs={6}>
                    <FloatingLabel controlId="floatingInput" label="Supplier GSTIN" className="mb-3">
                      <Input
                        type="text"
                        name="supplierGstin"
                        value={grnForm.supplierGstin}
                        onChange={handleChange}
                        placeholder="Supplier GSTIN"
                        disabled
                      />
                    </FloatingLabel>
                  </Col>
                  {/* -------------- */}
                  <Col xs={4}>
                    <FloatingLabel controlId="floatingInput" label="PO Number" className="mb-3">
                      <Input type="text" name="poNumber" value={grnForm.poNumber} onChange={handleChange} placeholder="PO Number" />
                    </FloatingLabel>
                  </Col>
                  <Col xs={4}>
                    <FloatingLabel controlId="floatingInput" label="Invoice Date" className="mb-3">
                      <Form.Control
                        type="date"
                        name="invoiceDate"
                        value={grnForm.invoiceDate}
                        onChange={handleChange}
                        placeholder="Invoice Date"
                        min={grnType === 'JW' && !admins && minDate}
                        max={maxDate}
                      />
                    </FloatingLabel>
                  </Col>
                  <Col xs={4}>
                    <FloatingLabel controlId="floatingInput" label="Supplier Invoice Number" className="mb-3">
                      <Input
                        type="text"
                        name="supplierInvoiceNumber"
                        value={grnForm.supplierInvoiceNumber}
                        onChange={handleChange}
                        placeholder="Supplier Invoice Number"
                        required={grnType === 'JW'}
                      />
                      {isCheckingDuplicate && (
                        <div className="position-absolute" style={{ right: '12px', top: '50%', transform: 'translateY(-50%)', zIndex: 10 }}>
                          <div
                            className="spinner-border spinner-border-sm text-primary"
                            role="status"
                            style={{ width: '16px', height: '16px' }}
                          >
                            <span className="visually-hidden">Checking...</span>
                          </div>
                        </div>
                      )}
                    </FloatingLabel>
                    {isDuplicateInvoice && (
                      <small className="text-danger" style={{ fontSize: '12px', marginTop: '1px', display: 'block' }}>
                        This invoice number already exists for this vendor
                      </small>
                    )}
                  </Col>
                  <Col xs={4}>
                    <FloatingLabel controlId="floatingInput" label="PO Date" className="mb-3">
                      <Form.Control
                        type="date"
                        name="poDate"
                        value={grnForm.poDate}
                        onChange={handleChange}
                        placeholder="PO Date"
                        max={maxDate}
                      />
                    </FloatingLabel>
                  </Col>
                  <Col xs={4}>
                    <FloatingLabel controlId="floatingInput" label="DC Number" className="mb-3">
                      <Input type="text" name="dcNumber" value={grnForm.dcNumber} onChange={handleChange} placeholder="DC Number" />
                    </FloatingLabel>
                  </Col>
                  <Col xs={4}>
                    <FloatingLabel controlId="floatingInput" label="DC Date" className="mb-3">
                      <Input type="date" name="dcDate" value={grnForm.dcDate} onChange={handleChange} placeholder="DC Date" />
                    </FloatingLabel>
                  </Col>
                </Row>

                <Row className="mb-2 align-items-center">
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <h6 className="mb-0">GRN details:</h6>
                    {currentDraft && !isSavingDraft && (
                      <span className="badge bg-info" style={{ fontSize: '0.75rem' }}>
                        Working on: {currentDraft.name}
                      </span>
                    )}
                  </div>
                </Row>
                {inputFields.map((inputField, index) => {
                  return (
                    <>
                      <div key={index} className="asset-info">
                        <Row className="align-items-center" wrap={true}>
                          <Col xs={4} className="mb-3">
                            <Item
                              itemId={inputField.itemId}
                              onChange={(itemId) => handleItemChange(index, itemId)}
                              name="itemId"
                              isDisabled={view === true}
                              query={grnType === 'JW' ? 'type=JW' : ''}
                              locationId={grnForm.factoryId}
                            />
                          </Col>
                          <Col xs={2}>
                            <FloatingLabel controlId="floatingInput" label="HSN Code" className="mb-3">
                              <Input disabled type="text" name="hsnCode" value={inputField.hsnCode} placeholder="HSN Code" />
                            </FloatingLabel>
                          </Col>
                          <Col xs={2}>
                            <FloatingLabel controlId="floatingInput" label="Unit" className="mb-3">
                              <select
                                required
                                disabled
                                name="unit"
                                value={inputField.unit}
                                onChange={(e) => handleInputChange(index, e, 'unit')}
                                aria-label="Floating label select example"
                                className="form-select"
                              >
                                <option value="">Select Unit</option>
                                {units.map((item, index) => (
                                  <option key={index} value={item.value}>
                                    {item?.label}
                                  </option>
                                ))}
                              </select>
                            </FloatingLabel>
                          </Col>
                          <Col xs={4}>
                            <FloatingLabel controlId="floatingInput" label="Description" className="mb-3">
                              <Input
                                type="text"
                                name="description"
                                value={inputField.description}
                                onChange={(e) => handleInputChange(index, e, 'description')}
                                placeholder="Description"
                              />
                            </FloatingLabel>
                          </Col>
                          <Col xs={4}>
                            <FloatingLabel controlId="floatingInput" label="Quantity As Per Invoice" className="mb-3">
                              <Input
                                type="text"
                                disabled={view === true}
                                name="quantityAsPerInvoice"
                                value={inputField.quantityAsPerInvoice}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (!isNaN(value) && value >= 0) {
                                    handleInputChange(index, e, 'quantityAsPerInvoice');
                                  }
                                }}
                                placeholder="Quantity As Per Invoice"
                                required
                              />
                            </FloatingLabel>
                          </Col>
                          <Col xs={4}>
                            <FloatingLabel controlId="floatingInput" label="Quantity Received" className="mb-3">
                              <Input
                                type="text"
                                disabled={view === true}
                                name="quantityReceived"
                                value={inputField.quantityReceived}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (!isNaN(value) && value >= 0) {
                                    handleInputChange(index, e, 'quantityReceived');
                                  }
                                }}
                                placeholder="Quantity Received"
                                required
                              />
                            </FloatingLabel>
                          </Col>
                          <Col xs={4}>
                            <FloatingLabel controlId="floatingInput" label="Rate Per Unit" className="mb-3">
                              <Input
                                type="text"
                                name="rate"
                                value={inputField.rate}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (!isNaN(value) && value >= 0) {
                                    handleInputChange(index, e, 'rate');
                                  }
                                }}
                                placeholder="Rate Per Unit"
                                required
                              />
                            </FloatingLabel>
                          </Col>
                          <Row>
                            <Row>
                              <Col xs={4}>
                                <FloatingLabel controlId="floatingInput" label="GST Type" className="mb-3">
                                  <Form.Select
                                    className="input"
                                    value={inputField.gstType}
                                    name="gstType"
                                    onChange={(e) => handleInputChange(index, e, 'gstType')}
                                    required
                                  >
                                    <option value="">Select GST</option>
                                    <option value="local">Local GST</option>
                                    <option value="interstate">Inter State GST</option>
                                  </Form.Select>
                                </FloatingLabel>
                              </Col>
                              {inputField.gstType === 'local' && (
                                <>
                                  <Col xs={4}>
                                    <FloatingLabel controlId="floatingInput" label="CGST" className="mb-3">
                                      <Form.Select
                                        className="input"
                                        value={inputField.cgst}
                                        name="cgst"
                                        onChange={(e) => handleInputChange(index, e, 'cgst')}
                                        required
                                      >
                                        <option value="">Select CGST</option>
                                        <option value="0">0%</option>
                                        <option value="1.5">1.5%</option>
                                        <option value="2.5">2.5%</option>
                                        <option value="6">6%</option>
                                        <option value="9">9%</option>
                                        <option value="14">14%</option>
                                      </Form.Select>
                                    </FloatingLabel>
                                  </Col>
                                  <Col xs={4}>
                                    <FloatingLabel controlId="floatingInput" label="SGST" className="mb-3">
                                      <Form.Select
                                        disabled
                                        className="input"
                                        value={inputField.sgst}
                                        name="sgst"
                                        onChange={(e) => handleInputChange(index, e, 'sgst')}
                                        required
                                      >
                                        <option value="">Select SGST</option>
                                        <option value="0">0%</option>
                                        <option value="1.5">1.5%</option>
                                        <option value="2.5">2.5%</option>
                                        <option value="6">6%</option>
                                        <option value="9">9%</option>
                                        <option value="14">14%</option>
                                      </Form.Select>
                                    </FloatingLabel>
                                  </Col>
                                </>
                              )}
                              {inputField.gstType === 'interstate' && (
                                <Col xs={4}>
                                  <FloatingLabel controlId="floatingInput" label="IGST" className="mb-3">
                                    <Form.Select
                                      className="input"
                                      value={inputField.igst}
                                      name="igst"
                                      onChange={(e) => handleInputChange(index, e, 'igst')}
                                      required
                                    >
                                      <option value="">Select IGST</option>
                                      <option value="0">0%</option>
                                      <option value="3">3%</option>
                                      <option value="5">5%</option>
                                      <option value="12">12%</option>
                                      <option value="18">18%</option>
                                      <option value="28">28%</option>
                                    </Form.Select>
                                  </FloatingLabel>
                                </Col>
                              )}
                            </Row>
                            <Col xs={3}>
                              <FloatingLabel controlId="floatingInput" label="Total Without GST" className="mb-3">
                                <Form.Control
                                  disabled
                                  className="input"
                                  name="totalWithoutGST"
                                  value={inputField?.totalWithoutGST}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    if (!isNaN(value) && value >= 0) {
                                      handleInputChange(index, e, 'totalWithoutGST');
                                    }
                                  }}
                                  type="text"
                                  placeholder="Total Without GST"
                                />
                              </FloatingLabel>
                            </Col>
                            {inputField.gstType === 'local' && (
                              <>
                                <Col xs={3}>
                                  <FloatingLabel controlId="floatingInput" label="Total CGST" className="mb-3">
                                    <Form.Control
                                      className="input"
                                      name="totalCGST"
                                      value={inputField?.totalCGST}
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        if (!isNaN(value) && value >= 0) {
                                          handleInputChange(index, e, 'totalCGST');
                                        }
                                      }}
                                      type="text"
                                      disabled
                                      placeholder="Total CGST"
                                    />
                                  </FloatingLabel>
                                </Col>
                                <Col xs={3}>
                                  <FloatingLabel controlId="floatingInput" label="Total SGST" className="mb-3">
                                    <Form.Control
                                      disabled
                                      className="input"
                                      name="totalSGST"
                                      value={inputField?.totalSGST}
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        if (!isNaN(value) && value >= 0) {
                                          handleInputChange(index, e, 'totalSGST');
                                        }
                                      }}
                                      type="text"
                                      placeholder="Total SGST"
                                    />
                                  </FloatingLabel>
                                </Col>
                              </>
                            )}
                            {inputField.gstType === 'interstate' && (
                              <Col xs={3}>
                                <FloatingLabel controlId="floatingInput" label="Total IGST" className="mb-3">
                                  <Form.Control
                                    disabled
                                    className="input"
                                    name="totalIGST"
                                    value={inputField?.totalIGST}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      if (!isNaN(value) && value >= 0) {
                                        handleInputChange(index, e, 'totalIGST');
                                      }
                                    }}
                                    type="text"
                                    placeholder="Total IGST"
                                  />
                                </FloatingLabel>
                              </Col>
                            )}
                            <Col xs={3}>
                              <FloatingLabel controlId="floatingInput" label="Invoice Amount" className="mb-3">
                                <Input
                                  type="text"
                                  name="invoiceAmount"
                                  value={inputField?.invoiceAmount}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    if (!isNaN(value) && value >= 0) {
                                      handleInputChange(index, e, 'invoiceAmount');
                                    }
                                  }}
                                  placeholder="Invoice Amount"
                                  disabled
                                />
                              </FloatingLabel>
                            </Col>
                          </Row>
                          <Col xs={4}>
                            <FloatingLabel controlId="floatingInput" label="Quantity Rejected" className="mb-3">
                              <Input
                                type="text"
                                name="quantityRejected"
                                value={inputField.quantityRejected}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (!isNaN(value) && value >= 0) {
                                    handleInputChange(index, e, 'quantityRejected');
                                  }
                                }}
                                placeholder="Quantity Rejected"
                                disabled
                              />
                            </FloatingLabel>
                          </Col>
                          <Col xs={4}>
                            <FloatingLabel className="mb-3" controlId="floatingInput" label="Remarks for Rejection">
                              <Input
                                type="text"
                                name="remarksForRejection"
                                value={inputField.remarksForRejection}
                                onChange={(e) => handleInputChange(index, e, 'remarksForRejection')}
                                placeholder="Remarks for Rejection"
                                required={inputField.quantityRejected > 0}
                              />
                            </FloatingLabel>
                          </Col>
                          {view === true ? (
                            ''
                          ) : (
                            <Col xs={1} className="text-end mb-3">
                              {inputFields.length > 1 && (
                                <MdDelete
                                  onClick={() => handleRemoveInput(index)}
                                  className="text-danger"
                                  style={{ cursor: 'pointer', fontSize: '27px' }}
                                />
                              )}
                            </Col>
                          )}
                        </Row>
                      </div>
                      <hr />
                    </>
                  );
                })}
                <Row className="mb-2">
                  <Col xs={4}>
                    {view === true ? (
                      ''
                    ) : (
                      <Button type="button" ref={clickAssetBtn} variant="secondary" size="sm" onClick={handleAddInput}>
                        Add Items
                      </Button>
                    )}
                  </Col>
                  <Col xs={4}>
                    {view === true || grnForm.id ? (
                      ''
                    ) : (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <Button type="button" variant="outline-primary" size="sm" onClick={saveDraft} disabled={isSavingDraft}>
                          {isSavingDraft ? (
                            <>
                              <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> Saving...
                            </>
                          ) : (
                            'Save Draft'
                          )}
                        </Button>
                        {currentDraft && (
                          <span className="badge bg-success" style={{ fontSize: '0.6rem' }}>
                            Draft: {currentDraft.name}
                          </span>
                        )}
                      </div>
                    )}
                  </Col>
                </Row>
                <hr />
                <Row style={{ display: 'flex' }}>
                  <Col xs={4}>
                    <Form.Select
                      disabled={view === true}
                      className="input mb-3"
                      name="chargeType"
                      value={grnForm.chargeType}
                      onChange={handleChange}
                    >
                      <option value="">Select Charge Type</option>
                      <option value="transport">Transport Charges</option>
                      <option value="other">Other</option>
                    </Form.Select>
                    {grnType === 'JW' && !grnForm.id && (
                      <Form.Control
                        required
                        onChange={(e) => setGrnForm({ ...grnForm, invoice: e.target.files[0] })}
                        name="invoice"
                        type="file"
                      />
                    )}
                  </Col>
                  <Col xs={4}>
                    <Form.Control
                      disabled={view === true || grnForm.chargeType === ''}
                      className="input"
                      name="chargeAmount"
                      value={grnForm.chargeAmount}
                      type="number"
                      onChange={handleChange}
                      placeholder="Charge Amount"
                    />
                  </Col>
                  <Col xs={4} className="text-end px-3">
                    <h6>Total Without GST: {totals?._totalWithoutGST?.toFixed(2)}</h6>
                    <h6>CGST: {totals?._totalCGST?.toFixed(2)}</h6>
                    <h6>SGST: {totals?._totalSGST?.toFixed(2)}</h6>
                    <h6>IGST: {totals?._totalIGST?.toFixed(2)}</h6>
                    <h6>Charges: {grnForm.chargeAmount}</h6>
                    <hr />
                    <h6 className="text-danger">Total: {subTotal?.toFixed(2)}</h6>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Button
                      style={{ backgroundColor: '#18c6d5' }}
                      onClick={() => setGrnPreview(true)}
                      className="add-request-btn justify-content-center"
                    >
                      Preview
                    </Button>
                    {loading ? (
                      <Button className="add-request-btn mt-4 mb-3 justify-content-center" variant="primary" disabled>
                        <Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" />
                        Loading...
                      </Button>
                    ) : (
                      <Button
                        type="submit"
                        ref={clickSubmitBtn}
                        className="add-request-btn mt-4 mb-3 justify-content-center"
                        disabled={loading}
                      >
                        Submit
                      </Button>
                    )}
                  </Col>
                </Row>
              </Form>
            )}
          </Modal.Body>
        </Modal>
      )}
      <Modal size="sm" show={uploadModel} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header>
          <Modal.Title>Upload Invoice</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Control onChange={handleFileChange} name="invoice" type="file" />
        </Modal.Body>
        <Modal.Footer>
          <div className="btn-wrapper">
            <button
              onClick={() => {
                setIdToUpdated('');
                setUploadModel(false);
              }}
              className="btn app-btn-default btn-sm"
            >
              Cancel
            </button>
            <button onClick={(e) => handleUpload(e, idToUpdated)} className="btn app-btn-primary btn-sm">
              Upload
            </button>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal size="xl" show={viewDetail} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header>
          <Modal.Title>GRN Details</Modal.Title>
          <button type="button" className="btn-close" aria-label="Close" onClick={handleClose}></button>
        </Modal.Header>
        <Modal.Body>
          <GrnDetail data={grnForm} isPrint={false} grnType={grnType} />
        </Modal.Body>
      </Modal>
      {grnPreview && (
        <Modal size="xl" show={grnPreview} backdrop="static" keyboard={false} className="request-modal">
          <Modal.Header>
            <Modal.Title>GRN Preview</Modal.Title>
            <button type="button" className="btn-close" aria-label="Close" onClick={() => setGrnPreview(false)}></button>
          </Modal.Header>
          <Modal.Body>
            <GrnPreview data={{ ...grnForm, totalAmount: subTotal?.toFixed(2) }} grnType={grnType} />
          </Modal.Body>
        </Modal>
      )}

      {/* Drafts Modal */}
      <Modal size="md" show={showDraftsModal} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header>
          <Modal.Title>Load Draft</Modal.Title>
          <button type="button" className="btn-close" aria-label="Close" onClick={() => setShowDraftsModal(false)}></button>
        </Modal.Header>
        <Modal.Body>
          {isLoadingDrafts ? (
            <div className="text-center">
              <Spinner animation="border" variant="primary" />
              <p>Loading drafts...</p>
            </div>
          ) : drafts.length === 0 ? (
            <p className="text-center">No drafts found</p>
          ) : (
            <div>
              {drafts.map((draft) => (
                <div key={draft.id} className="d-flex justify-content-between align-items-center border-bottom py-2">
                  <div>
                    <strong>{draft.name}</strong>
                    <br />
                    <small className="text-primary">
                      {draft.saveData?.grnForm?.supplierName || 'No vendor'} |{' '}
                      {draft.saveData?.grnForm?.supplierInvoiceNumber || 'No invoice number'}
                    </small>
                    <br />
                    <small className="text-muted">Updated: {new Date(draft.updatedAt).toLocaleDateString()}</small>
                  </div>
                  <div>
                    <button
                      type="button"
                      className="btn app-btn-primary btn-sm me-2"
                      onMouseEnter={(e) => {
                        e.target.style.boxShadow = '0 0 0 0.2rem rgba(0, 123, 255, 0.25)';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.boxShadow = '';
                      }}
                      onClick={() => loadDraft(draft.id)}
                    >
                      Load
                    </button>
                    <MdDelete
                      style={{ fontSize: '16px', color: 'red', cursor: 'pointer' }}
                      onClick={() => deleteDraft(draft.id)}
                      title="Delete Draft"
                    />
                  </div>
                </div>
              ))}
            </div>
          )}
        </Modal.Body>
      </Modal>

      {/* Draft Name Modal */}
      <Modal size="sm" show={showDraftNameModal} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header>
          <Modal.Title>Save Draft</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>Draft Name</Form.Label>
            <Form.Control
              type="text"
              value={draftName}
              onChange={(e) => setDraftName(e.target.value)}
              placeholder="Enter draft name"
              autoFocus
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn app-btn-default btn-sm"
            onClick={() => {
              setShowDraftNameModal(false);
              setDraftName('');
            }}
          >
            Cancel
          </button>
          <button type="button" className="btn app-btn-primary btn-sm" onClick={createDraft} disabled={isSavingDraft}>
            {isSavingDraft ? (
              <>
                <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> Saving...
              </>
            ) : (
              'Save'
            )}
          </button>
        </Modal.Footer>
      </Modal>

      {/* Debit Note Modal */}
      <AddInvDebitNoteModal
        open={debitNoteData.open}
        grnId={debitNoteData.grnId}
        onClose={() => setDebitNoteData({ ...debitNoteData, open: false })}
        factories={getLocationsForUser(locationList, 'factory', isAdmin())}
      />
    </React.Fragment>
  );
};

export default GRN;
